import React, { useState, useEffect, useCallback } from 'react';
import { MapPin, Calendar, ArrowRight } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { getEvents } from '../api/api';

const EventCard = ({ event }) => {
  return (
    <Card className="group overflow-hidden hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 border-none h-full">
      <div className="relative h-64 lg:h-80 overflow-hidden">
        <img
          src={event.imageUrl}
          alt={event.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute top-4 left-4 bg-[#FF1B6D] text-white px-4 py-2 rounded-full font-bold text-sm shadow-lg">
          <Calendar size={16} className="inline mr-2" />
          {event.date}
        </div>
      </div>
      <CardContent className="p-8">
        <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-[#FF1B6D] transition-colors duration-300">
          {event.title}
        </h3>
        <div className="flex items-center text-gray-600 mb-4">
          <MapPin size={18} className="mr-2 text-[#FF1B6D]" />
          <span className="font-medium">{event.location}</span>
        </div>
        <p className="text-gray-600 leading-relaxed">
          {event.description}
        </p>
      </CardContent>
    </Card>
  );
};

export const EventsSection = () => {
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchEvents = useCallback(async () => {
    try {
      const data = await getEvents();
      setEvents(data);
    } catch (error) {
      console.error('Error fetching events:', error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchEvents();
  }, [fetchEvents]);

  if (isLoading) {
    return (
      <section id="evenements" className="py-20 lg:py-32 bg-white">
        <div className="container mx-auto px-4 lg:px-8 text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#FF1B6D] mx-auto"></div>
        </div>
      </section>
    );
  }

  return (
    <section id="evenements" className="py-20 lg:py-32 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-black text-gray-900 mb-4">
            Événements à Venir
          </h2>
          <div className="w-24 h-1 bg-[#FF1B6D] mx-auto"></div>
        </div>

        {events.length > 0 ? (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 mb-12">
            {events.map((event) => (
              <EventCard key={event.id} event={event} />
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <p className="text-gray-500 text-lg">Aucun événement pour le moment</p>
          </div>
        )}

        <div className="text-center">
          <Button
            variant="outline"
            className="border-2 border-[#FF1B6D] text-[#FF1B6D] hover:bg-[#FF1B6D] hover:text-white font-bold text-lg px-8 py-6 rounded-full transition-all duration-300 transform hover:scale-105"
          >
            Voir tous les événements
            <ArrowRight className="ml-2" size={20} />
          </Button>
        </div>
      </div>
    </section>
  );
};